export const routes = [
  ...require('./economy-unit/routes').routes,
  ...require('./client-unit/routes').routes,
  ...require('./address-unit/routes').routes,
  ...require('./attachment-unit/routes').routes,
  ...require('./service-observation/routes').routes,
  ...require('./history-unit/routes').routes
]
